export default __webpack_public_path__ + "static/media/call-button.a5699752.svg";